<script>
import t from "@/components/page/HomeView/data/text.json";
import { mapGetters } from "vuex";

export default {
  props: ["page"],
  data() {
    return {
      isOpen: false,
      t,
    };
  },
  computed: {
    ...mapGetters(["getIsMobile"]),
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
  },
  watch: {
    isOpen(newVal, old) {
      document.body.classList[newVal ? "add" : "remove"]("noscroll");
    },
  },
};
</script>

<template>
  <div class="float">
    <div class="float__open app-btn-circle" @click="toggle">
      <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M18 22H38" stroke="white" stroke-width="2" />
        <path d="M18 28H38" stroke="white" stroke-width="2" />
        <path d="M18 34H38" stroke="white" stroke-width="2" />
      </svg>
    </div>

    <Transition>
      <div v-if="isOpen" class="float__overlay"></div>
    </Transition>

    <div :class="{ active: isOpen }" class="float__menu-list">
      <div class="float__menu-list-scroll">
        <router-link
          @click="toggle"
          :to="item.link"
          class="float__item"
          v-for="(item, id) in t.itemPages"
          :key="id"
        >
          <div class="float__img">
            <div class="float__img-icon app-btn-circle">
              <img
                v-if="item.iconType === 'Статья'"
                class="list-page__img-icon--icon1"
                src="@/assets/icons/ui/t_1.svg"
                alt="icon"
              />
              <img
                v-if="item.iconType === 'видео'"
                class="list-page__img-icon--icon2"
                src="@/assets/icons/ui/t_2.svg"
                alt="icon"
              />
              <img
                v-if="item.iconType === 'Квиз'"
                class="list-page__img-icon--icon3"
                src="@/assets/icons/ui/t_3.svg"
                alt="icon"
              />
              <img
                v-if="item.iconType === 'Материал для пациентов'"
                class="list-page__img-icon--icon4"
                src="@/assets/icons/ui/t_4.svg"
                alt="icon"
              />
            </div>

            <picture>
              <source
                :srcset="`${require('@/assets/img/ui/items/mob/' +
                  item.img +
                  '.webp')} 1x, ${require('@/assets/img/ui/items/mob/' +
                  item.img +
                  '@2x.webp')} 2x`"
                type="image/webp"
              />
              <img
                class="float__img-main"
                :src="require(`@/assets/img/ui/items/mob/${item.img}.png`)"
                :srcset="`${require('@/assets/img/ui/items/mob/' +
                  item.img +
                  '.png')} 1x, ${require('@/assets/img/ui/items/mob/' +
                  item.img +
                  '@2x.png')} 2x`"
                :alt="`${item.name}`"
              />
            </picture>
          </div>
          <div class="float__col">
            <p class="float__type" v-html="item.iconType"></p>
            <h2 class="float__title" v-html="item.name"></h2>
          </div>
        </router-link>
      </div>

      <div class="float__close app-btn-circle small" @click="toggle">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="56"
          height="56"
          viewBox="0 0 56 56"
          fill="none"
        >
          <path d="M20.1592 20L36 36" stroke="white" stroke-width="2" />
          <path d="M35.8407 20L19.9999 36" stroke="white" stroke-width="2" />
        </svg>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.float {
  &__open {
    z-index: 200;
    position: fixed;
    right: 60px;
    bottom: 70px;

    @media screen and (max-width: 1024px) {
      right: 40px;
      bottom: 40px;
    }
  }

  &__overlay {
    position: fixed;
    z-index: 300;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    background: rgba(14, 45, 34, 0.9);
    backdrop-filter: blur(3px);

    &.v-enter-active,
    &.v-leave-active {
      transition: opacity 1s ease-in-out;
    }

    &.v-enter-from,
    &.v-leave-to {
      opacity: 0;
    }
  }

  &__close {
    position: absolute;
    right: 20px;
    bottom: 20px;
  }

  &__item {
    display: flex;
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }

    @media screen and (min-width: 1024px) {
      &:hover {
        user-select: none;

        .float__img-icon {
          // border: 1px solid rgba(255, 255, 255, 0.25);

          &::before {
            background: radial-gradient(
                100% 100% at 50% 0%,
                rgba(255, 255, 255, 1) 0%,
                rgba(255, 255, 255, 0) 100%
              ),
              linear-gradient(0deg, #22b28a 0%, #6fd691 100%);
          }

          &::after {
            background: linear-gradient(0deg, #01cb93 0%, #60fe94 100%);
          }
        }
      }
    }

    &:active {
      user-select: none;

      .float__img-icon {
        &::before {
          background: radial-gradient(
              100% 100% at 50% 0%,
              rgba(255, 255, 255, 1) 0%,
              rgba(255, 255, 255, 0) 100%
            ),
            linear-gradient(0deg, rgba(255, 255, 255, 0.3) 0%, #ffffff00 100%),
            linear-gradient(0deg, #22b28a 0%, #6fd691 100%);
        }

        &::after {
          background: radial-gradient(
              66.84% 40% at 50% 0%,
              rgba(255, 255, 255, 0.8) 0%,
              rgba(255, 255, 255, 0) 100%
            ),
            linear-gradient(0deg, #00a175 0%, #60fe94 100%);
        }
      }
    }
  }

  &__menu-list {
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;

    max-width: 394px;
    width: 100%;

    background: var(--164031_BG, #164031);

    transition: transform 1s ease-in-out;
    transform: translateX(100%);
    z-index: 9999999;

    @media screen and (max-width: 600px) {
      max-width: 600px;
      padding: 10px;
    }

    &-scroll {
      padding: 40px 17px;

      min-height: calc(100vh);
      min-height: calc((var(--vh, 1vh) * 100));

      max-height: calc(100vh);
      max-height: calc((var(--vh, 1vh) * 100));

      overflow-y: auto;

      display: flex;
      flex-direction: column;

      @media screen and (max-width: 600px) {
        padding: 10px 10px;
        max-height: calc(100vh - 20px);
        min-height: calc(100vh - 20px);
      }

      @media screen and (max-width: 1024px) and (max-height: 600px) {
        max-height: calc(100vh);
        min-height: calc(100vh);
      }
    }

    &.active {
      transform: translateX(0);
    }
  }

  &__img {
    max-width: 156px;
    min-width: 156px;
    width: 100%;
    position: relative;

    &-main {
      width: 100%;
      height: auto;
      display: block;
    }

    &-icon {
      position: absolute;
      right: 0;
      top: 0;

      width: 22.5%;
      height: 29.01%;

      img {
        position: relative;
        z-index: 2;

        height: auto;
        display: block;
      }
    }
  }

  &__col {
    margin-left: 20px;

    @media screen and (max-width: 1024px) {
    }

    @media screen and (max-width: 600px) {
    }
  }

  &__type {
    color: var(--Accent-Purple, #e482ff);
    font-size: 10px;
    font-style: normal;
    font-weight: 700;
    line-height: 14px;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    margin-bottom: 4px;
    @media screen and (max-width: 1024px) {
    }
  }

  &__title {
    color: var(--Text-White, #fff);
    font-family: "MetaPro", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 110%;
    text-transform: uppercase;

    @media screen and (max-width: 1024px) {
    }
  }
}
</style>
